// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================================
   PopupVideo (intro video popup)  |  prefix: popup_video_pg_
   overlay (fixed) > dialog > player + footer
   ===================================================================== */

/* ---------- Overlay ---------- */
.popup_video_pg_overlay {
  position: fixed;
  inset: 0;
  z-index: 10001; /* header / drawer-ku mela */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(24, 10, 52, 0.58);
  backdrop-filter: blur(8px);
  overflow-y: auto;
  overscroll-behavior: contain;
  animation: popup_video_pg_overlay_in 0.3s ease both;
}

.popup_video_pg_overlay_out {
  animation: popup_video_pg_overlay_out 0.26s ease both;
}

/* ---------- Dialog ---------- */
.popup_video_pg_dialog {
  width: 100%;
  max-width: 640px;
  margin: auto;
  padding: 12px;
  border-radius: 20px;
  background: linear-gradient(180deg, #ffffff 0%, #f7f2ff 100%);
  box-shadow: 0 30px 80px rgba(24, 10, 52, 0.45), 0 0 0 1px rgba(255, 255, 255, 0.7) inset;
  font-family: "Manrope", "Sora", sans-serif;
  color: #0f0a2a;
  box-sizing: border-box;
  animation: popup_video_pg_dialog_in 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.popup_video_pg_overlay_out .popup_video_pg_dialog {
  animation: popup_video_pg_dialog_out 0.26s ease both;
}

.popup_video_pg_dialog *,
.popup_video_pg_dialog *::before,
.popup_video_pg_dialog *::after {
  box-sizing: border-box;
}

/* ---------- Player ---------- */
.popup_video_pg_player {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 14px;
  background: #1a0a3a;
  overflow: hidden;
  transform: translateZ(0); /* keeps the rounded corners on video in Safari */
}

.popup_video_pg_video {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #1a0a3a;
  pointer-events: none; /* no native controls / menus */
}

/* dark fade at the bottom so the time + button stay readable */
.popup_video_pg_shade {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 38%;
  background: linear-gradient(180deg, rgba(20, 8, 44, 0) 0%, rgba(20, 8, 44, 0.55) 100%);
  pointer-events: none;
}

.popup_video_pg_time {
  position: absolute;
  left: 14px;
  bottom: 16px;
  z-index: 2;
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
  color: #ffffff;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.45);
}

/* ---------- Unmute ---------- */
.popup_video_pg_mute {
  position: absolute;
  right: 12px;
  bottom: 14px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 14px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 999px;
  background: rgba(20, 8, 44, 0.5);
  backdrop-filter: blur(8px);
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 700;
  line-height: 1;
  color: #ffffff;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background-color 0.25s ease, transform 0.25s ease;
}

.popup_video_pg_mute:hover {
  background: rgba(64, 21, 159, 0.85);
  transform: translateY(-1px);
}

.popup_video_pg_mute:focus-visible,
.popup_video_pg_btn_primary:focus-visible,
.popup_video_pg_btn_ghost:focus-visible {
  outline: 3px solid #e0a83d;
  outline-offset: 2px;
}

/* ---------- Progress line ---------- */
.popup_video_pg_track {
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: 6px;
  z-index: 2;
  height: 3px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.28);
  overflow: hidden;
}

.popup_video_pg_fill {
  display: block;
  height: 100%;
  border-radius: 3px;
  background: #e0a83d;
  transition: width 0.3s linear;
}

/* ---------- Footer ---------- */
.popup_video_pg_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 4px 4px;
}

.popup_video_pg_caption {
  flex: 1 1;
  min-width: 0;
  margin: 0;
  font-size: 12.5px;
  line-height: 1.45;
  color: #5d5978;
}

.popup_video_pg_actions {
  display: flex;
  flex-shrink: 0;
  gap: 10px;
}

.popup_video_pg_btn_primary,
.popup_video_pg_btn_ghost {
  min-height: 42px;
  padding: 10px 20px;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease;
}

.popup_video_pg_btn_primary {
  border: 0;
  background: linear-gradient(100deg, #40159f 0%, #7a1fc4 100%);
  box-shadow: 0 10px 22px rgba(64, 21, 159, 0.32);
  color: #ffffff;
}

.popup_video_pg_btn_ghost {
  border: 1px solid #e4dcf9;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(64, 21, 159, 0.08);
  color: #0f0a2a;
}

.popup_video_pg_btn_primary:active,
.popup_video_pg_btn_ghost:active {
  transform: scale(0.97);
}

@media (hover: hover) {
  .popup_video_pg_btn_primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 28px rgba(64, 21, 159, 0.42);
  }

  .popup_video_pg_btn_ghost:hover {
    transform: translateY(-2px);
    background: #f4eefe;
  }
}

/* ---------- Phones ---------- */
@media (max-width: 560px) {
  .popup_video_pg_overlay {
    padding: 10px;
  }

  .popup_video_pg_dialog {
    padding: 10px;
    border-radius: 16px;
  }

  .popup_video_pg_player {
    border-radius: 11px;
  }

  .popup_video_pg_footer {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 12px 2px 2px;
  }

  .popup_video_pg_actions {
    width: 100%;
  }

  .popup_video_pg_btn_primary {
    flex: 1 1;
  }

  .popup_video_pg_mute {
    padding: 7px 11px;
    font-size: 12px;
  }
}

@media (max-height: 480px) and (orientation: landscape) {
  .popup_video_pg_overlay {
    align-items: flex-start;
    padding: 8px;
  }

  .popup_video_pg_dialog {
    max-width: min(640px, calc((100dvh - 120px) * 16 / 9));
  }
}

/* ---------- Keyframes ---------- */
@keyframes popup_video_pg_overlay_in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes popup_video_pg_overlay_out {
  from { opacity: 1; }
  to   { opacity: 0; }
}

@keyframes popup_video_pg_dialog_in {
  from { opacity: 0; transform: translateY(34px) scale(0.94); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes popup_video_pg_dialog_out {
  from { opacity: 1; transform: translateY(0) scale(1); }
  to   { opacity: 0; transform: translateY(22px) scale(0.96); }
}

/* ---------- Reduced motion ---------- */
@media (prefers-reduced-motion: reduce) {
  .popup_video_pg_overlay,
  .popup_video_pg_dialog {
    animation: none !important;
  }

  .popup_video_pg_fill,
  .popup_video_pg_mute,
  .popup_video_pg_btn_primary,
  .popup_video_pg_btn_ghost {
    transition: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/POPUP/PopupVideo/PopupVideo.css"],"names":[],"mappings":"AAAA;;;0EAG0E;;AAE1E,kCAAkC;AAClC;EACE,eAAe;EACf,QAAQ;EACR,cAAc,EAAE,4BAA4B;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAElC,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,mDAAmD;AACrD;;AAEA;EACE,qDAAqD;AACvD;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,wFAAwF;EACxF,0CAA0C;EAC1C,cAAc;EACd,sBAAsB;EACtB,4EAA4E;AAC9E;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB,EAAE,iDAAiD;AAC7E;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB,EAAE,+BAA+B;AACvD;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,sFAAsF;EACtF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,cAAc;EACd,0CAA0C;AAC5C;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,oBAAoB;EACpB,gCAAgC;EAEhC,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,6DAA6D;AAC/D;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,oFAAoF;AACtF;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE;IACE,2BAA2B;IAC3B,+CAA+C;EACjD;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,sDAAsD;EACxD;AACF;;AAEA,oCAAoC;AACpC;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD,OAAO,UAAU,EAAE,uCAAuC,EAAE;AAC9D;;AAEA,yCAAyC;AACzC;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;;;;IAIE,2BAA2B;EAC7B;AACF","sourcesContent":["/* =====================================================================\n   PopupVideo (intro video popup)  |  prefix: popup_video_pg_\n   overlay (fixed) > dialog > player + footer\n   ===================================================================== */\n\n/* ---------- Overlay ---------- */\n.popup_video_pg_overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10001; /* header / drawer-ku mela */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(24, 10, 52, 0.58);\n  -webkit-backdrop-filter: blur(8px);\n  backdrop-filter: blur(8px);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  animation: popup_video_pg_overlay_in 0.3s ease both;\n}\n\n.popup_video_pg_overlay_out {\n  animation: popup_video_pg_overlay_out 0.26s ease both;\n}\n\n/* ---------- Dialog ---------- */\n.popup_video_pg_dialog {\n  width: 100%;\n  max-width: 640px;\n  margin: auto;\n  padding: 12px;\n  border-radius: 20px;\n  background: linear-gradient(180deg, #ffffff 0%, #f7f2ff 100%);\n  box-shadow: 0 30px 80px rgba(24, 10, 52, 0.45), 0 0 0 1px rgba(255, 255, 255, 0.7) inset;\n  font-family: \"Manrope\", \"Sora\", sans-serif;\n  color: #0f0a2a;\n  box-sizing: border-box;\n  animation: popup_video_pg_dialog_in 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.popup_video_pg_overlay_out .popup_video_pg_dialog {\n  animation: popup_video_pg_dialog_out 0.26s ease both;\n}\n\n.popup_video_pg_dialog *,\n.popup_video_pg_dialog *::before,\n.popup_video_pg_dialog *::after {\n  box-sizing: border-box;\n}\n\n/* ---------- Player ---------- */\n.popup_video_pg_player {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  border-radius: 14px;\n  background: #1a0a3a;\n  overflow: hidden;\n  transform: translateZ(0); /* keeps the rounded corners on video in Safari */\n}\n\n.popup_video_pg_video {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: #1a0a3a;\n  pointer-events: none; /* no native controls / menus */\n}\n\n/* dark fade at the bottom so the time + button stay readable */\n.popup_video_pg_shade {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 38%;\n  background: linear-gradient(180deg, rgba(20, 8, 44, 0) 0%, rgba(20, 8, 44, 0.55) 100%);\n  pointer-events: none;\n}\n\n.popup_video_pg_time {\n  position: absolute;\n  left: 14px;\n  bottom: 16px;\n  z-index: 2;\n  font-size: 12px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n  color: #ffffff;\n  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.45);\n}\n\n/* ---------- Unmute ---------- */\n.popup_video_pg_mute {\n  position: absolute;\n  right: 12px;\n  bottom: 14px;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 8px 14px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  border-radius: 999px;\n  background: rgba(20, 8, 44, 0.5);\n  -webkit-backdrop-filter: blur(8px);\n  backdrop-filter: blur(8px);\n  font-family: inherit;\n  font-size: 12.5px;\n  font-weight: 700;\n  line-height: 1;\n  color: #ffffff;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  transition: background-color 0.25s ease, transform 0.25s ease;\n}\n\n.popup_video_pg_mute:hover {\n  background: rgba(64, 21, 159, 0.85);\n  transform: translateY(-1px);\n}\n\n.popup_video_pg_mute:focus-visible,\n.popup_video_pg_btn_primary:focus-visible,\n.popup_video_pg_btn_ghost:focus-visible {\n  outline: 3px solid #e0a83d;\n  outline-offset: 2px;\n}\n\n/* ---------- Progress line ---------- */\n.popup_video_pg_track {\n  position: absolute;\n  left: 14px;\n  right: 14px;\n  bottom: 6px;\n  z-index: 2;\n  height: 3px;\n  border-radius: 3px;\n  background: rgba(255, 255, 255, 0.28);\n  overflow: hidden;\n}\n\n.popup_video_pg_fill {\n  display: block;\n  height: 100%;\n  border-radius: 3px;\n  background: #e0a83d;\n  transition: width 0.3s linear;\n}\n\n/* ---------- Footer ---------- */\n.popup_video_pg_footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 14px 4px 4px;\n}\n\n.popup_video_pg_caption {\n  flex: 1;\n  min-width: 0;\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: #5d5978;\n}\n\n.popup_video_pg_actions {\n  display: flex;\n  flex-shrink: 0;\n  gap: 10px;\n}\n\n.popup_video_pg_btn_primary,\n.popup_video_pg_btn_ghost {\n  min-height: 42px;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 13.5px;\n  font-weight: 700;\n  line-height: 1.2;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  transition: transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease;\n}\n\n.popup_video_pg_btn_primary {\n  border: 0;\n  background: linear-gradient(100deg, #40159f 0%, #7a1fc4 100%);\n  box-shadow: 0 10px 22px rgba(64, 21, 159, 0.32);\n  color: #ffffff;\n}\n\n.popup_video_pg_btn_ghost {\n  border: 1px solid #e4dcf9;\n  background: #ffffff;\n  box-shadow: 0 4px 12px rgba(64, 21, 159, 0.08);\n  color: #0f0a2a;\n}\n\n.popup_video_pg_btn_primary:active,\n.popup_video_pg_btn_ghost:active {\n  transform: scale(0.97);\n}\n\n@media (hover: hover) {\n  .popup_video_pg_btn_primary:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 14px 28px rgba(64, 21, 159, 0.42);\n  }\n\n  .popup_video_pg_btn_ghost:hover {\n    transform: translateY(-2px);\n    background: #f4eefe;\n  }\n}\n\n/* ---------- Phones ---------- */\n@media (max-width: 560px) {\n  .popup_video_pg_overlay {\n    padding: 10px;\n  }\n\n  .popup_video_pg_dialog {\n    padding: 10px;\n    border-radius: 16px;\n  }\n\n  .popup_video_pg_player {\n    border-radius: 11px;\n  }\n\n  .popup_video_pg_footer {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    padding: 12px 2px 2px;\n  }\n\n  .popup_video_pg_actions {\n    width: 100%;\n  }\n\n  .popup_video_pg_btn_primary {\n    flex: 1;\n  }\n\n  .popup_video_pg_mute {\n    padding: 7px 11px;\n    font-size: 12px;\n  }\n}\n\n@media (max-height: 480px) and (orientation: landscape) {\n  .popup_video_pg_overlay {\n    align-items: flex-start;\n    padding: 8px;\n  }\n\n  .popup_video_pg_dialog {\n    max-width: min(640px, calc((100dvh - 120px) * 16 / 9));\n  }\n}\n\n/* ---------- Keyframes ---------- */\n@keyframes popup_video_pg_overlay_in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes popup_video_pg_overlay_out {\n  from { opacity: 1; }\n  to   { opacity: 0; }\n}\n\n@keyframes popup_video_pg_dialog_in {\n  from { opacity: 0; transform: translateY(34px) scale(0.94); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes popup_video_pg_dialog_out {\n  from { opacity: 1; transform: translateY(0) scale(1); }\n  to   { opacity: 0; transform: translateY(22px) scale(0.96); }\n}\n\n/* ---------- Reduced motion ---------- */\n@media (prefers-reduced-motion: reduce) {\n  .popup_video_pg_overlay,\n  .popup_video_pg_dialog {\n    animation: none !important;\n  }\n\n  .popup_video_pg_fill,\n  .popup_video_pg_mute,\n  .popup_video_pg_btn_primary,\n  .popup_video_pg_btn_ghost {\n    transition: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
